DO.Subscribe('app:ready', (e, $) => {
  function initCounter() {
    $('.stats-list .stats-item:not(.stats-text) > h1').counterUp({
      delay: 10,
      time: 1000,
    });
  }
  initCounter();
});
